import { NextPage, GetStaticProps, GetStaticPaths } from 'next';

import CompaniesPrefecturesCommon from '@components_iqfu/public/companies_prefectures_common/CompaniesPrefecturesCommon';
import {
  CompaniesPrefecturePageProps,
  getStaticPathsCompaniesPrefecturesCommon,
  getStaticPropsCompaniesPrefecturesCommon,
} from '@components_iqfu/public/companies_prefectures_common/staticRenderFunctions';

import { CompaniesPagesData } from 'src/iqfu/data/companiesPagesData';

const pageRenderParameter = CompaniesPagesData.prefecture.mansion;

export const getStaticPaths: GetStaticPaths = async () => {
  return getStaticPathsCompaniesPrefecturesCommon(pageRenderParameter.prerender_pages_list);
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  return getStaticPropsCompaniesPrefecturesCommon(params, pageRenderParameter);
};

const CompaniesMansionPrefecture: NextPage<CompaniesPrefecturePageProps> = ({ data }) => {
  const renderProps = {
    pageRenderParameter,
    ...data,
  };
  return <CompaniesPrefecturesCommon {...renderProps} />;
};

export default CompaniesMansionPrefecture;
